import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, Kpi, KpiGrid, Muted, PageHeader, Section } from '@/components/ui'
import { fetchAnalyticsDashboard, fetchIndicadoresRh } from './api'

function num(v: unknown) {
  const n = typeof v === 'number' ? v : Number(v)
  return Number.isFinite(n) ? n.toLocaleString('pt-BR') : '—'
}

export function IndicadoresPage() {
  const ind = useQuery({ queryKey: ['rh', 'indicadores'], queryFn: fetchIndicadoresRh })
  const analytics = useQuery({
    queryKey: ['analytics', 'dashboard'],
    queryFn: fetchAnalyticsDashboard,
  })

  const entries = Object.entries(ind.data || {}).filter(
    ([, v]) => typeof v === 'number' || typeof v === 'string',
  )

  return (
    <section className="hi-page">
      <PageHeader
        title="Indicadores"
        subtitle="Indicadores avançados de RH e scores organizacionais."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/indicadores')}>
            Legado
          </a>
        }
      />

      {ind.isLoading ? <Muted>Carregando…</Muted> : null}
      {ind.isError ? (
        <Alert tone="danger">
          {ind.error instanceof ApiError ? ind.error.message : 'Falha ao carregar indicadores.'}
        </Alert>
      ) : null}

      {entries.length > 0 ? (
        <Section title="RH">
          <KpiGrid>
            {entries.slice(0, 12).map(([k, v]) => (
              <Kpi key={k} label={k.replace(/_/g, ' ')} value={num(v)} />
            ))}
          </KpiGrid>
        </Section>
      ) : null}

      {analytics.data ? (
        <Section title="Analytics">
          <KpiGrid>
            <Kpi label="Engajamento" value={num(analytics.data.score_engajamento_medio)} />
            <Kpi label="Score geral" value={num(analytics.data.score_geral_medio)} />
            <Kpi label="Alertas críticos" value={num(analytics.data.alertas_criticos)} />
          </KpiGrid>
        </Section>
      ) : null}
    </section>
  )
}
